import { render } from "./characteristics.vue?vue&type=template&id=1101355d"
import script from "./characteristics.vue?vue&type=script&lang=js"
export * from "./characteristics.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__